var map = {
	"./PG Cards Thumbnails/MAEnglish.jpeg": 6294,
	"./PG Cards Thumbnails/MCom.jpeg": 9932,
	"./PG Cards Thumbnails/MSc_Bio_Technology.JPG": 9255,
	"./PG Cards Thumbnails/MSc_Computer_Science.JPG": 5276,
	"./PG Cards Thumbnails/MSc_Mathematics.jpeg": 6768,
	"./PG/MA_English.jpeg": 8515,
	"./PG/MCom.jpeg": 2594,
	"./PG/MSc_Bio_Technology.jpeg": 9965,
	"./PG/MSc_Computer_Science.jpeg": 1956,
	"./PG/MSc_Maths.jpeg": 3655,
	"./PG/PG-BT/GnanslinSheeba.JPG": 2501,
	"./PG/PG-BT/Sangeetha.JPG": 2647,
	"./PG/PG-BT/Sukitha.jpeg": 8032,
	"./PG/PG-CS/KrishnaPrasad.jpeg": 6550,
	"./PG/PG-CS/Rajalakshmi.JPG": 620,
	"./PG/PG-Eng/MohamedMurshitha.jpeg": 1427,
	"./UG Cards Thumbnails/Bsc_Bio_Technology.JPG": 918,
	"./UG Cards Thumbnails/Bsc_Chemistry.JPG": 2278,
	"./UG Cards Thumbnails/Bsc_Computer_Science.JPG": 5966,
	"./UG Cards Thumbnails/Bsc_Hotel_Management.JPG": 2250,
	"./UG Cards Thumbnails/Bsc_Information_Technology.JPG": 8301,
	"./UG Cards Thumbnails/Bsc_Mathematics.jpeg": 1,
	"./UG Cards Thumbnails/Bsc_Micro_Biology.JPG": 6936,
	"./UG Cards Thumbnails/Bsc_Nutrition_Diabetics.JPG": 5059,
	"./UG Cards Thumbnails/Bsc_Visual_Communication.JPG": 6559,
	"./UG Cards Thumbnails/ai_profile_img.jpg": 8380,
	"./UG Cards Thumbnails/baEnglish.jpeg": 7268,
	"./UG Cards Thumbnails/bba.jpeg": 1180,
	"./UG Cards Thumbnails/bca.JPG": 8403,
	"./UG Cards Thumbnails/bcom.jpeg": 3610,
	"./UG/Activity Images/sports.jpeg": 5668,
	"./UG/BA_English.jpeg": 2279,
	"./UG/BBA.jpeg": 9688,
	"./UG/BBA/SheebaChristilda.JPG": 6802,
	"./UG/BBA/Sugitha.JPG": 5594,
	"./UG/BCA-faculty/DrSKala.jpg": 8990,
	"./UG/BCA-faculty/Kala-min.JPG": 2445,
	"./UG/BCA-faculty/Kala.JPG": 442,
	"./UG/BCA-faculty/Mabel-min.JPG": 8835,
	"./UG/BCA-faculty/Mabel.JPG": 3836,
	"./UG/BCA-faculty/MohamedKhan-min.JPG": 4605,
	"./UG/BCA-faculty/MohamedKhan.JPG": 7402,
	"./UG/BCA-faculty/SophinSeeli-min.JPG": 9229,
	"./UG/BCA-faculty/SophinSeeli.JPG": 6522,
	"./UG/BCOM/Babudhas.JPG": 6039,
	"./UG/BCOM/Marimuthu.jpeg": 5641,
	"./UG/BCOM/Remya.jpeg": 6759,
	"./UG/BCOM/Sajitha.jpeg": 581,
	"./UG/BCOM/reghuKumar.jpg": 9775,
	"./UG/BCom.jpeg": 654,
	"./UG/BSCAI/PriyaNair.jpeg": 1331,
	"./UG/BSCAI/StanlySherin.jpeg": 5734,
	"./UG/BSc_Bio_Technology.jpeg": 9081,
	"./UG/BSc_Chemistry.jpeg": 8698,
	"./UG/BSc_Computer_Application.jpeg": 4520,
	"./UG/BSc_Computer_Science.jpeg": 2960,
	"./UG/BSc_Hotel_Management.jpeg": 6236,
	"./UG/BSc_Information_Technology.jpeg": 5825,
	"./UG/BSc_Maths.jpeg": 419,
	"./UG/BSc_Micro_Biology.jpeg": 5624,
	"./UG/BSc_Nutrition.jpeg": 6504,
	"./UG/BSc_Visual_Communication.jpeg": 3659,
	"./UG/BT/Anupa.JPG": 4775,
	"./UG/BT/MeeraSabari.JPG": 1024,
	"./UG/BT/Poornima.JPG": 3555,
	"./UG/BscChemistry/JosephHepzin.jpeg": 801,
	"./UG/BscChemistry/ShiningVinilPriya.jpeg": 8563,
	"./UG/CS-faculties/Akila.jpeg": 1357,
	"./UG/CS-faculties/Asha.JPG": 8842,
	"./UG/CS-faculties/JebaFreeda.JPG": 3588,
	"./UG/CS-faculties/Ramya.JPG": 5405,
	"./UG/CS-faculties/SankarGopu.JPG": 1008,
	"./UG/English/AjilaJothi.JPG": 2075,
	"./UG/English/AshlinShelina.jpeg": 5033,
	"./UG/English/Janardhanan.JPG": 4712,
	"./UG/English/Sabitha.jpeg": 8568,
	"./UG/HM/Mohandhas.JPG": 2786,
	"./UG/IT/Avudayappapillai.JPG": 8756,
	"./UG/IT/Deepa.JPG": 3906,
	"./UG/IT/Sunitha.JPG": 109,
	"./UG/MB/Dhanya.JPG": 1624,
	"./UG/MB/Sreedevi.jpeg": 9430,
	"./UG/MB/blessy.jpeg": 9377,
	"./UG/Maths/Murugesan.JPG": 3762,
	"./UG/Nutrition/JosephineBeneditBai.JPG": 8634,
	"./UG/Viscom/CibySKumar.JPG": 7261,
	"./UG/Viscom/MOHAMMEDYAZEEN.jpeg": 3319,
	"./UG/ai_profile_img.jpg": 7872,
	"./femaleavatar.jpg": 2972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3191;